export default __webpack_public_path__ + "static/consumer-hotspot-c8e0e1ee461f11afb8e82d80054df03a.gif";